interface NestedResourceVisibilityState {
    archived?: boolean;
    hidden?: boolean;
}

const isNestedResourceTabVisible = ({ archived, hidden }: NestedResourceVisibilityState) =>
    archived !== true && hidden !== true;

const getNestedResourceVisibilityCounts = (resources: NestedResourceVisibilityState[]) =>
    resources.reduce(
        (counts, resource) => {
            if (resource.archived === true) {
                counts.archivedCount += 1;
            } else if (resource.hidden === true) {
                counts.hiddenCount += 1;
            }

            return counts;
        },
        { archivedCount: 0, hiddenCount: 0 },
    );

export { getNestedResourceVisibilityCounts, isNestedResourceTabVisible };
export type { NestedResourceVisibilityState };
